import React, { forwardRef, ReactChild } from 'react'

import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel'

import ArrowLeftBlue from '@/presentation/assets/svg/ArrowLeftBlue.svg'
import ArrowRightBlue from '@/presentation/assets/svg/ArrowRightBlue.svg'
import { useResolution } from '@/services/hooks/useResolution'

import '@/presentation/components/Carousel/styles.css'

interface CarouselProps {
  children: ReactChild[]
  handleCarouselItemClick: (index: number) => void
}

const Carousel: React.ForwardRefRenderFunction<
  ResponsiveCarousel,
  CarouselProps
> = ({ children, handleCarouselItemClick }, forwardRef) => {
  const { isSmallDesktop } = useResolution()

  return (
    <ResponsiveCarousel
      statusFormatter={(currentSlide, total) => `${currentSlide} / ${total}`}
      renderIndicator={() => null}
      renderThumbs={() => []}
      onClickItem={handleCarouselItemClick}
      ref={forwardRef}
      width={isSmallDesktop ? '100%' : '680px'}
      renderArrowPrev={onClickHandler => (
        <button
          className="absolute bottom-[6px] left-[calc(50%-52px)] z-10 cursor-pointer"
          type="button"
          title="Próximo"
          onClick={onClickHandler}
        >
          <img src={ArrowLeftBlue} alt="Left arrow icon" />
        </button>
      )}
      renderArrowNext={onClickHandler => (
        <button
          className="absolute bottom-[6px] right-[calc(50%-52px)] z-10 cursor-pointer"
          type="button"
          title="Próximo"
          onClick={onClickHandler}
        >
          <img src={ArrowRightBlue} alt="Right arrow icon" />
        </button>
      )}
      emulateTouch
      showStatus
      showArrows
    >
      {children}
    </ResponsiveCarousel>
  )
}

export default forwardRef(Carousel)
